import { Map }     from 'immutable';
import PropType    from 'prop-types';
import { connect } from 'react-redux';
import {
  compose,
  setDisplayName,
  wrapDisplayName
}                  from 'recompose';
import {
  disableEditMode,
  enableEditMode
}                  from '../actions';
import {
  selectDraftContent,
  selectDraftContentNames,
  selectRegisteredContent
}                  from '../selectors/editableContentSelectors';


export const PROP_HAS_EDITABLE_CONTENT = 'hasEditableContent';
export const PROP_EDITABLE_CONTENT     = 'editableContent';
export const PROP_HAS_EDITED_CONTENT   = 'hasEditedContent';
export const PROP_EDITED_CONTENT       = 'editedContent';
export const PROP_EDITED_CONTENT_NAMES = 'editedContentNames';
export const PROP_BEGIN_EDITING        = 'beginEditing';
export const PROP_END_EDITING          = 'endEditing';


const hocName = 'MapEditableContent';


/**
 * Adds `hasEditableContent` & `editableContent` props to component, based on the `userCapabilities` prop.
 *
 * If all editable content is required, set `userCapabilities` to '*'.
 *
 * @param {?function} innerComponent Inner component.  If provided, is used to create the display name.
 *
 * @return {function(*=): *}
 */
const mapEditableContent = ({innerComponent} = {}) => (Component) => compose(
  setDisplayName((innerComponent && wrapDisplayName(innerComponent, hocName)) || hocName),
  connect(
    () => {

      return (state) => {

        return {
          [PROP_HAS_EDITABLE_CONTENT]: !!selectRegisteredContent(state).count(),
          [PROP_EDITABLE_CONTENT]:     selectRegisteredContent(state),
          [PROP_HAS_EDITED_CONTENT]:   !selectDraftContent(state).isEmpty(),
          [PROP_EDITED_CONTENT]:       selectDraftContent(state),
          [PROP_EDITED_CONTENT_NAMES]: selectDraftContentNames(state),
        };

      };

    },

    dispatch => ({
      [PROP_BEGIN_EDITING]: () => dispatch(enableEditMode()),
      [PROP_END_EDITING]:   () => dispatch(disableEditMode()),
    }),
  ),
)(Component);


export const MapEditableContentPropTypes = {

  // Flag ot indicate whether there is any editable content on the page.
  [PROP_HAS_EDITABLE_CONTENT]: PropType.bool,

  // Editable content on items on the page.
  // This is filtered to the items editable with the `userCapabilities` prop values.
  [PROP_EDITABLE_CONTENT]: PropType.instanceOf(Map),

  // Callback to set the 'inEditMode' state to true.
  [PROP_BEGIN_EDITING]: PropType.func,

  // Callback to set the 'inEditMode' state to false.
  [PROP_END_EDITING]: PropType.func,

};


export default mapEditableContent;


// WEBPACK FOOTER //
// ./src/modules/editableContent/components/mapEditableContent.js